import React from 'react'
import { Redirect, useHistory, useParams } from 'react-router-dom'
import { SectionHeading, SettingsLayout } from 'src/components/app-ui'
import UserAccess from 'src/components/user-access'
import Badge from 'src/components/user-access/components/badge'
import Collaboration from 'src/pages/collection/components/collection-page-view/components/collection-settings/components/collaboration'
import WhiteLabeling from 'src/pages/collection/components/collection-page-view/components/collection-settings/components/white-label'
import { tabPath } from '../tabs'
import GeneralSection from './general-section'
import WebhookSection from './webhook-section'

const LearnerAuthSection = () => (
  <>
    <SectionHeading
      title="Learners' authentication"
      description="Select who can access and how."
    />
    <UserAccess />
  </>
)

/** `value` is the `settings/:subPage` URL segment. */
const SECTIONS = [
  {
    value: 'learner-authentication',
    label: "Learners' authentication",
    icon: 'tabler:key',
    Component: LearnerAuthSection,
  },
  {
    value: 'general',
    label: 'General',
    icon: 'tabler:settings',
    Component: GeneralSection,
  },
  {
    value: 'white-labeling',
    label: 'White labeling',
    icon: 'tabler:mail',
    Component: WhiteLabeling,
  },
  {
    value: 'collaboration',
    label: 'Collaboration',
    icon: 'tabler:users',
    badge: <Badge type={8} />,
    Component: Collaboration,
  },
  {
    value: 'integrations',
    label: 'Webhook',
    icon: 'tabler:webhook',
    Component: WebhookSection,
  },
]

const SettingsTab = () => {
  const history = useHistory()
  const { id, subPage } = useParams()

  // Certification used to live under settings; it is its own tab now.
  if (subPage === 'certification') {
    return <Redirect to={tabPath(id, 'certification')} />
  }
  // The custom domain is set up at workspace level.
  if (subPage === 'custom-domain') {
    return <Redirect to="/workspace/custom-domain" />
  }

  const active =
    SECTIONS.find(section => section.value === subPage) || SECTIONS[0]
  const { Component } = active

  return (
    <SettingsLayout
      items={SECTIONS}
      value={active.value}
      onChange={value => history.push(tabPath(id, 'settings', value))}
    >
      <Component />
    </SettingsLayout>
  )
}

export default SettingsTab
